module.exports = __webpack_public_path__ + "img/Mobile APP.57a71fe3.png";